const PrivatePage = () => {
  return (
    <div className="page">
      <h2>Private Page</h2>
      <p>Access Allowed only to LoggedIn Users!🤟🔥</p>
    </div>
  );
};

export default PrivatePage;
